import { AddCreditCardRequest } from '../../../models/ss-api/requests/add.credit.card.request';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { CreditCardResponse, CreditCardTypes } from '../../../models/ss-api/responses/credit.card.response';
import { Component, OnInit } from '@angular/core';
import { ssApiService } from 'app/services/ss-api.service';
import { CreditCardResponseArray } from 'app/models/ss-api/responses/credit.card.response';
import { HttpError } from 'app/models/errors/HttpError';
import { CreditCardValidators, CreditCard } from 'angular-cc-library';
import { MemberBasicInfoResponse } from 'app/models/ss-api/responses/member.basic.info.response';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { DialogService } from 'primeng/dynamicdialog';
import { EditCreditCardDialogComponent, IEditCreditCardDialogModel } from 'app/dialogs/edit-credit-card/edit-credit-card-dialog.component';
import { GlobalServices } from 'app/services/global.service';
import { MemberProfile } from 'app/models/domain/member.profile';

import { CreditCardHelper } from '../../../helpers/creditcard';
import { CountryList, CountryListItem } from '../../../helpers/country.list';
import { Router } from '@angular/router';


function CustomCreditCardValidator(c: UntypedFormControl) {
    
    let cardType = CreditCardHelper.GetCardTypes( c.value );

    if( cardType == CreditCardTypes.Unknown || cardType == null ) {
        return {
            CustomCreditCardValidator: {
                valid: false
            }
        }
    } else {
        return null;
    }

}

@Component({
    selector: 'manage-credit-cards',
    templateUrl: './manage-credit-cards.component.html',
    styleUrls: ['./manage-credit-cards.component.scss'],
    providers: [DialogService]
})
export class ManageCreditCardsComponent implements OnInit {

    // dialog confirm add creditcard
    Add_Confirm_Title: string = 'Add New Credit Card?';
    Add_Confirm_Text: string = 'You are about to add a new Credit Card.';

    // dialog added info
    Add_Added_Title: string = 'Saved!';
    Add_Added_Text: string = 'New Credit Card Saved.';
    Add_Added_Timeout: number = 1500;

    // dialog confirm delete creditcard
    Delete_Confirm_Title: string = 'Delete Credit Card?';
    Delete_Confirm_Text: string = 'You are about to delete a Credit Card.';

    // dialog deleted info
    Delete_Deleted_Title: string = 'Deleted!';
    Delete_Deleted_Text: string = 'Credit Card Deleted.';
    Delete_Deleted_Timeout: number = 1500;

    // dialog confirm set default creditcard
    SetDefault_Confirm_Title: string = 'Change default Credit Card?';
    SetDefault_Confirm_Text: string = 'You are about to change your default Credit Card.';

    // dialog default saved info
    SetDefault_Saved_Title: string = 'Saved!';
    SetDefault_Saved_Text: string = 'New default Credit Card saved.';
    SetDefault_Saved_Timeout: number = 1500;

    TabIndex: number = 1;
    submitted: boolean = false;
    ccardForm: UntypedFormGroup;
    ccForm: UntypedFormGroup;
    formSetAsDefaultVisible: boolean = true;
    showEditCreditCardModal: boolean;

	public updateAddress : boolean = false;

    public IsBusy: boolean = false;

	memberProfile : MemberProfile;

    public MemberBasicInfo: MemberBasicInfoResponse = new MemberBasicInfoResponse();
    public Cards: CreditCardResponseArray = new CreditCardResponseArray();
    public DefaultCard: CreditCardResponse = new CreditCardResponse();

	countryList : CountryListItem[] = CountryList.Countries();

    constructor(
        private router: Router,
        private api: ssApiService,
        private _fb: UntypedFormBuilder,
		private dialogService: DialogService,
		public gb : GlobalServices
		) {
    }


    ngOnInit() {
        window.scrollTo(0, 0);
        //Check to see if we're defaulting to adding a card
        if(this.router.url == "/account/add-credit-card"){
            this.TabIndex = 1;
        }
        else{
            this.TabIndex = 0;
        }
        
        this.RefreshCards();

        this.ccForm = this._fb.group({
            creditCard: new UntypedFormControl('', [<any>CreditCardValidators.validateCCNumber, CustomCreditCardValidator]),
            expMonth: [this.ThisMonth(), [Validators.required]],
            expYear: [new Date().getFullYear(), [Validators.required]],
            cvc: ['', [<any>Validators.required, <any>Validators.minLength(3), <any>Validators.maxLength(4)]],
            firstName: [],
            lastName: []
        });

        this.ccardForm = this._fb.group({
            creditCard: this.ccForm,
			
			address1 : new UntypedFormControl("", [Validators.required]),
			city : new UntypedFormControl( "", [Validators.required]),
			state : new UntypedFormControl( "", [Validators.required]),
			zip : new UntypedFormControl( "", [Validators.required, Validators.minLength(1), Validators.maxLength(10) ]),
			country : new UntypedFormControl( "", [Validators.required, Validators.minLength(1)]),
			
			setAsDefault: new UntypedFormControl( true )
        });


		this.GetMemberProfile();


    }


	

	GetMemberProfile() {
		this.IsBusy = true;
		
		

        let disposable = this.api.MemberProfile().subscribe(result => {

            disposable.unsubscribe();
			console.log('MemberProfile Result -', result);
			
			
			this.memberProfile = result.Data;

			this.UpdateGBmemberInfo();

			
        }, error => {
			disposable.unsubscribe();
			this.IsBusy = false;
			console.log("ERROR", error);
		});

	}

	UpdateGBmemberInfo() {
		this.IsBusy = true;

		let disposable = this.gb.onMemberProfileUpdated.subscribe( response => {
			disposable.unsubscribe();
			this.IsBusy = false;

			console.log("I got a member profile", response);

			this.UpdateFormWithMemberData();
			
		});

		this.gb.CheckMemberInfo();

	}

	firstTimeSetup : boolean = true;

	UpdateFormWithMemberData() {

		let newCountry = CountryList.ValidCountry( this.memberProfile.Country );
		
		this.ccardForm.patchValue({
			companyName : this.memberProfile.Companyname,
			email : this.memberProfile.Email,

			address1 : this.memberProfile.Address1,

			city : this.memberProfile.City,
			state : this.memberProfile.State,
			zip : this.memberProfile.Postcode,
			country : CountryList.ValidCountry( this.memberProfile.Country ),

			phone : this.gb.FormattedPhone(this.memberProfile.Phonenumber),
			phone2 : this.gb.FormattedPhone(this.memberProfile.Phonenumber2),
			fax : this.memberProfile.FaxNumber,

			currentPassword : '',
			newPassword : ''

		});

		this.ccardForm.updateValueAndValidity();

		if( !this.firstTimeSetup ) return;


		


		this.ccardForm.controls.country.valueChanges.subscribe( v => {

			console.log(v);

			if( v == "US" ) {
				this.ccardForm.controls.zip.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(10) ]);
			} else {
				this.ccardForm.controls.zip.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(10) ]);
			}

			this.ccardForm.controls.zip.updateValueAndValidity();
		} );


		this.firstTimeSetup = false;

	}

	IsUS() : boolean {
		return this.ccardForm.controls.country.value == 'US' ? true : false;
	}


    isValidExpiration() {
        let ccExpMonth = this.ccForm.get('expMonth').value;
        let ccExpYear = this.ccForm.get('expYear').value;

        if (moment(ccExpMonth + '/' + ccExpYear, 'MM/YYYY').isSameOrAfter(moment(moment().format('MM/YYYY'), 'MM/YYYY'))) {
            return true;
        } else {
            return false;
        }
    }

    ThisMonth() {
        const month = new Date().getMonth() + 1;

        if (month < 10) {
            return '0' + month;
        } else {
            return month;
        }
    }

    ProcessDefaultCardArray(newDefaultCardID: number) {

        // reset default card and put in global array
        this.DefaultCard.IsDefault = false;
        this.Cards.push(this.DefaultCard);

        // find default card
        let index = this.Cards.findIndex(x => x.ID == newDefaultCardID);

        // set default card
        this.DefaultCard = this.Cards[index];
        this.DefaultCard.IsDefault = true;

        // remove default card from list
        this.Cards.splice(index, 1);

    }


    SetAsDefault(id: number) {

        // confirm
        Swal.fire({
            title: this.SetDefault_Confirm_Title,
            text: this.SetDefault_Confirm_Text,
            icon: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Yes, save!',
            cancelButtonText: 'No, cancel',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                // addcard
                return this.SetCardAsDefault(id);
            }
        })
            .then(
                (response: any) => {

                    if (response.isDismissed) {
                        // show cancelled
                        Swal.fire({
                            title: 'Cancelled',
                            text: 'No changes are saved.',
                            icon: 'error',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1000
                        })
                            .then(() => { }, () => { }); // keep this line to prevent promise error;
                    } else {
                        // show confirmation
                        Swal.fire({
                            title: this.SetDefault_Saved_Title,
                            text: this.SetDefault_Saved_Text,
                            icon: 'success',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: this.SetDefault_Saved_Timeout
                        })
                        .then(() => { }, () => { }); // keep this line to prevent promise error;
                    }

                },
                (dismiss) => {
                    if (dismiss === 'cancel') {

                        if (!confirm)
                            return;

                        // show cancelled
                        Swal.fire({
                            title: 'Cancelled',
                            text: 'No changes are saved.',
                            icon: 'error',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1000
                        })
                            .then(() => { }, () => { }); // keep this line to prevent promise error;
                    }
                });

    }

    SetCardAsDefault(id: number): Promise<any> {

        this.IsBusy = true;

        return this.api.CreditCardSetDefault(id)
            .toPromise()
            .then(response => {

                this.IsBusy = false;

                if (!response.Result)
                    return; // error

                // ok
                this.ProcessDefaultCardArray(id);

            })
            .catch((error: HttpError) => {
                this.IsBusy = false;
            });

    }

    EditCreditCard(item: CreditCardResponse) {
        let data: IEditCreditCardDialogModel = {
            CreditCard: item
        };
        const ref = this.dialogService.open(EditCreditCardDialogComponent, {
            data,
            modal: false,
            maskStyleClass: 'opened',
            draggable: true,
            keepInViewport: true
        });
        ref.onClose.subscribe(({isUpdated, setAsDefault}) => {
            if (setAsDefault) {
                this.SetCardAsDefault(item.ID)
            }
            if (isUpdated) {
                this.RefreshCards();
            }
        });
        this.RefreshCards();
    }

    Delete(id: number) {

        // confirm
        Swal.fire({
            title: this.Delete_Confirm_Title,
            text: this.Delete_Confirm_Text,
            icon: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Yes, delete!',
            cancelButtonText: 'No, cancel',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                // addcard
                return this.DeleteCard(id);
            }
        })
            .then(
                (res) => {
                    // show confirmation
                    if (res.isConfirmed) {
                        Swal.fire(
                            {
                                title: this.Delete_Deleted_Title,
                                text: this.Delete_Deleted_Text,
                                icon: 'success',
                                showCancelButton: false,
                                showConfirmButton: false,
                                timer: this.Delete_Deleted_Timeout
                            })
                            .then(() => { }, () => { }); // keep this line to prevent promise error;    
                    } else {
                        // show cancelled
                        Swal.fire({
                            title: 'Cancelled',
                            text: 'No changes are saved.',
                            icon: 'error',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1000
                        })
                            .then(() => { }, () => { }); // keep this line to prevent promise error;
                    }
                });

    }

    DeleteCard(id: number): Promise<any> {

        this.IsBusy = true;

        return this.api.CreditCardDelete(id)
            .toPromise()
            .then(response => {

                this.IsBusy = false;

                if (!response.Result)
                    return; // error

                // ok

                let index = this.Cards.findIndex(x => x.ID == id);
                this.Cards.splice(index, 1);

            })
            .catch(
                (error: HttpError) => {
                    this.IsBusy = false;
                });


    }

    getExpDateMonth(month: string): string {

        try {

            // let month = expDate.split('/')[0].trim();
            if (month.length == 1)
                return '0' + month;
            else
                return month;

        } catch (e) {
            return '0';
        }
    }

    getExpDateYear(year: string): string {

        try {

            // let year = expDate.split('/')[1].trim();
            if (year.length == 2)
                return '20' + year;
            else
                return year;

        } catch (e) {
            return '0';
        }
    }

    getDateCreated(createdDate: Date): any {
        if (createdDate == undefined)
            return '';

        // let returnDate = createdDate.getDay() + "/" + createdDate.getMonth() + "/" + createdDate.getFullYear();
        let returnDate = moment(createdDate).format('MM/DD/YYYY');
        return returnDate;
    }

    RefreshCards(): void {

        this.IsBusy = true;

        let request = this.api.CreditCardGetAll()
            .subscribe(response => {
                request.unsubscribe();

                this.IsBusy = false;

                if (!response.Result)
                    return; // error

                if (response.Data.length == 0)
                    return;

                this.Cards = response.Data;

                // find default card
                let index = this.Cards.findIndex(x => x.IsDefault == true);

                // set default card
                this.DefaultCard = this.Cards[index];
                console.log("Default Card", this.DefaultCard);

                // remove default card from list
                this.Cards.splice(index, 1);

            },


                (error: HttpError) => {
                    request.unsubscribe();
                    this.IsBusy = false;
                }
            );


	}
}
